import { getLocalApi } from "./localApi";
import { AccommodationTypeValue} from "app/shared/model";
import apiConfig from "app/api/apiConfig.json";

export async function getAllAccommodationTypes() : Promise<AccommodationTypeValue[]> {
    const localApi = await getLocalApi();

    return await localApi.fetchList(apiConfig.reference_data_get_accommodation_types, (dto:any) => ({
        name: dto.name,
        id: dto.id
    }), 'Unable to fetch accommodation types')
}